import React from 'react';

import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import { Button, Chip, Stack } from '@mui/material';

import SortableRoomImageSlot from './SortableSlot';
import type { RoomImage } from './utils';

interface Props {
  hiddenImagePublicIds: Array<string>;
  image?: RoomImage;
  onDeleteImage: (publicId: string) => void;
  onEditImage: (publicId: string) => void;
  onOpenPicker: () => void;
  onToggleHiddenImage: (publicId: string) => void;
  slotNumber: number;
}

export default function ImagesByRoomSlot({
  hiddenImagePublicIds,
  image,
  onDeleteImage,
  onEditImage,
  onOpenPicker,
  onToggleHiddenImage,
  slotNumber,
}: Props) {
  const slotLabel = slotNumber === 1 ? `#${slotNumber} Hero` : `#${slotNumber}`;

  if (image) {
    return (
      <SortableRoomImageSlot
        image={image}
        isHidden={hiddenImagePublicIds.includes(image.publicId)}
        onDeleteImage={onDeleteImage}
        onEditImage={onEditImage}
        onToggleHiddenImage={onToggleHiddenImage}
        slotLabel={slotLabel}
      />
    );
  }

  return (
    <Button
      variant="text"
      onClick={onOpenPicker}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        aspectRatio: '16 / 9',
        width: '100%',
        border: 1,
        borderColor: 'grey.300',
        borderRadius: 1,
        bgcolor: 'grey.50',
        minWidth: 0,
        p: 0,
        '&:hover': {
          bgcolor: 'grey.100',
        },
      }}
    >
      <Stack alignItems="center" justifyContent="center" sx={{ width: '100%', height: '100%', color: 'grey.400' }}>
        <AddPhotoAlternateOutlinedIcon fontSize="large" />
      </Stack>
      <Chip label={slotLabel} size="small" sx={roomImageSlotChipSx} />
    </Button>
  );
}

const roomImageSlotChipSx = {
  position: 'absolute',
  top: 10,
  left: 10,
  bgcolor: 'grey.800',
  color: 'common.white',
  fontWeight: 700,
};
